import { render, staticRenderFns } from "./EventFono.vue?vue&type=template&id=784e2425&"
import script from "./EventFono.vue?vue&type=script&lang=js&"
export * from "./EventFono.vue?vue&type=script&lang=js&"
import style0 from "./EventFono.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports